<template>
  <div class="news-item__main-info">
    <component :is="titleHtmlTag" class="subtitle-2">
      <a-link :to="article.canonicalUrl" class="news-item__title subtitle-1">
        {{ article.title }}
      </a-link>
    </component>

    <a-hidden-time-for-crawlers :time="article.publishedOn" />

    <a-link :to="article.canonicalUrl">
      <a-tldr :tldr="article.tldr" class="news-item__tldr" />
    </a-link>

    <div>
      <a-obfuscated-display-time :time="article.publishedOn" class="date" />
      <span class="date"
        >by
        <a-authors :article="article" />
      </span>
    </div>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import ATldr from 'shared/ATldr'
import AAuthors from 'shared/AAuthors'
import { HTML_TAG } from '@/utils/helpers/processHtml/enums'
import AHiddenTimeForCrawlers from 'shared/PublishTime/AHiddenTimeForCrawlers/index.vue'
import AObfuscatedDisplayTime from 'shared/PublishTime/AObfuscatedDisplayTime/index.vue'

export default {
  name: 'MainInfo',
  components: {
    AObfuscatedDisplayTime,
    AHiddenTimeForCrawlers,
    ATldr,
    AAuthors
  },
  props: {
    article: propValidator([PROP_TYPES.OBJECT]),
    titleHtmlTag: propValidator([PROP_TYPES.STRING], false, HTML_TAG.HEADING_H3)
  }
}
</script>

<style lang="scss" scoped>
.news-item {
  &__title {
    display: inline-block;
    margin-bottom: 10px;

    @include mobile {
      font-size: 19px;
      line-height: 22px;
    }
  }

  &__tldr {
    margin-bottom: 15px;

    @include mobile {
      margin-bottom: 10px;
    }
  }
}
</style>
